<template>
  <loading
    :active.sync="isLoading"
    :can-cancel="false"
    :is-full-page="true"
    loader="bars"
    background-color="#000"
    color="secondary"
    width.number="180"
    height.number="180"
  />
</template>
<script>
// import userAPIs from '../User/userAPIs'
import instagramAPIs from './instagramAPIs';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'InstagramHandleAuth',
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false
    };
  },
  mounted() {
    this.isLoading = true;
    // Get code returned by Instagram
    const authCode = this.$route.query.code;
    if (!authCode) {
      // Redirect to main page
      this.$router.push({ name: 'Profile' });
      this.isLoading = false;
    } else {
      instagramAPIs
        .handleInstagramAuthCallback(authCode)
        .then(response => {
          this.isLoading = false;
          if (response.success) {
            let data = response.data
            const userData = data.userData;
            const jwtToken = data.jwtToken;
            /* Setting user in the state and caching record to the localStorage */
            var token = 'Bearer ' + jwtToken;

            this.$store.commit('SET_USER', userData);
            this.$store.commit('SET_TOKEN', token);

            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(userData));
              window.localStorage.setItem('token', token);
            }

            this.$router.push(this.$route.query.redirect ? this.$route.query.redirect : { name: 'Profile' });
          } else {
            this.$swal({
              title: 'Warning',
              text: response.message,
              type: 'warning'
            }).then(() => this.$router.push({ name: 'Login' }));
          }
        })
        .catch(error => {
          // Request failed.
          this.$swal({
            title: 'Error connecting to server.',
            text: 'Please kindly try again by different methods or contact us.',
            type: 'error'
          }).then(() => this.$router.push({ name: 'Login' }));
          this.isLoading = false;
          console.log('error', error);
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// handleAuth.vue?2f482095